// TODO DRY The content of this dir is copypasted from https://github.com/EvapolarLTD/eva-widgets/tree/master/packages/lib/components/Footer

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import classnames from 'classnames';

import logoImg from '../../../media/footer/logo.svg';
import arrowImg from '../../../media/footer/arrow.svg';
import fbImg from '../../../media/footer/social-fb.svg';
import twImg from '../../../media/footer/social-twitter.svg';
import instagramImg from '../../../media/footer/social-instagram.svg';
import { useFooter } from '../../hooks/use-footer';

import useStyles, { InputStatus, inputTheme } from './styled';
import { Container } from './ui/common';
import { Input } from './ui/input';
import { Spinner } from './ui/spinner';

export const Footer = () => {
  const classes = useStyles();
  const {
    email,
    status,
    handleEmailChange,
    handleEmailSubmit,
    getUrl,
    contactUs,
  } = useFooter();

  return (
    <footer className={classes.root}>
      <Container>
        <Grid container>
          <Grid item md={3} sm={4} xs={12} className={classes.block}>
            <Typography paragraph variant="h6" className={classes.title}>
              Learn
            </Typography>
            <Link href={getUrl('shop')} className={classes.link}>
              Evapolar Products
            </Link>
            <Link href={getUrl('technology')} className={classes.link}>
              Technology
            </Link>
            <Link href={getUrl('blog')} className={classes.link}>
              Blog
            </Link>
            <Link href={getUrl('aff-program')} className={classes.link}>
              Affiliate program
            </Link>
          </Grid>
          <Grid item md={3} sm={4} xs={12} className={classes.block}>
            <Typography paragraph variant="h6" className={classes.title}>
              Support
            </Typography>
            <Link href={getUrl('about')} className={classes.link} hidden>
              About
            </Link>
            <Link href="https://support.evapolar.com" className={classes.link}>
              Help Center
            </Link>
            <Link
              href="https://support.evapolar.com/hc/en-us/articles/115000899625-Return-Refund-policy"
              className={classes.link}
            >
              Returns
            </Link>
            <Link
              href="https://support.evapolar.com/hc/en-us/requests/new?ticket_form_id=360001043920"
              className={classes.link}
            >
              Technical Help
            </Link>
          </Grid>
          <Grid item md={3} sm={4} xs={12} className={classes.block}>
            <Typography paragraph variant="h6" className={classes.title}>
              Contact Us
            </Typography>
            <pre style={{ marginTop: 0 }} className={classes.link}>
              {contactUs}
            </pre>
          </Grid>
          <Grid
            item
            md={3}
            sm={12}
            xs={12}
            className={classnames(classes.block, classes.readyBlock)}
          >
            <Typography paragraph variant="h6" className={classes.title}>
              READY FOR BETTER? WE&#160;HOPE&#160;SO.
            </Typography>
            <Typography paragraph variant="h6" className={classes.textSignUp}>
              Sign up to Evapolar newsletter
            </Typography>
            <div>
              <Input
                name="email"
                label="EMAIL"
                value={email}
                onChange={handleEmailChange}
                autocomplete="email"
                icon={arrowImg}
                theme={inputTheme}
                onIconClick={handleEmailSubmit}
              />
              <InputStatus error={status.error}>
                {status.anim && <Spinner />}
                {status.text}
              </InputStatus>
            </div>
          </Grid>
        </Grid>

        <Grid container className={classes.container}>
          <Grid item sm={6} xs={12}>
            <img src={logoImg} alt="logo" className={classes.logo} />
            <Typography paragraph variant="h6" className={classes.copyright}>
              {`© Evapolar, 2016–${new Date().getFullYear()}`}
            </Typography>
          </Grid>
          <Grid item sm={6} xs={12}>
            <Grid container>
              <Grid container className={classes.containerSocial}>
                <div>
                  <Link
                    href="https://www.facebook.com/evapolarofficial/"
                    className={classes.link}
                  >
                    <img src={fbImg} className={classes.social} alt="social" />
                  </Link>
                </div>
                <div>
                  <Link
                    href="https://www.instagram.com/evapolar"
                    className={classes.link}
                  >
                    <img
                      src={instagramImg}
                      className={classes.social}
                      alt="social"
                    />
                  </Link>
                </div>
                <div>
                  <Link
                    href="https://twitter.com/evapolar_com"
                    className={classes.link}
                  >
                    <img src={twImg} className={classes.social} alt="social" />
                  </Link>
                </div>
              </Grid>
              <Grid container className={classes.containerItems}>
                <Link
                  href={getUrl('terms')}
                  className={classnames(classes.text, classes.textBottom)}
                >
                  Terms of Service
                </Link>
                <Link
                  href={getUrl('privacy-policy')}
                  className={classnames(classes.text, classes.textBottom)}
                >
                  Privacy Policy
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </footer>
  );
};
